import { Chart, Grid, UsersIcon } from 'components'
import { DCFilter } from 'types'
import { useBreakpoint } from 'utils'
import { StatTile } from '..'
import { getFilterValueParams, useEvent, useOnTheGo } from '../../utils'
import { useAggregations } from '../../utils/analyticsUtils'

export default function AnalyticsUserResponsesSection() {
  const isMobile = useBreakpoint() < 2
  const { event, filters: eventFilters = [], setFilters: setEventFilters } = useEvent()
  const { filters: onTheGoFilters = [], setFilters: setOnTheGoFilters } = useOnTheGo()
  const filters = event ? eventFilters : onTheGoFilters
  const setFilters = event ? setEventFilters : setOnTheGoFilters
  const { aggregations } = useAggregations([
    {
      table: 'leads',
      values: ['_count'],
      categories: ['optIn'],
      sort: { _count: 'DESC' },
      filters: filters,
    },
    {
      table: 'leads',
      values: ['_count'],
      categories: ['followUp'],
      sort: { _count: 'DESC' },
      filters: filters,
    },
  ])

  const [optIns, followUps] = aggregations || []
  const optInsCount =
    optIns?.data?.reduce((acc, cur) => (cur.optIn ? acc + Number(cur._count) : acc), 0) || 0
  const followUpsCount =
    followUps?.data?.reduce((acc, cur) => (cur.followUp ? acc + Number(cur._count) : acc), 0) || 0
  const renderSection = optInsCount > 0 || followUpsCount > 0

  function handleSelect(field: string, value: string) {
    const { operator, value: filterValue } = getFilterValueParams(field, value)
    const selectedFilters: DCFilter[] = [
      {
        field,
        operator,
        value: filterValue,
        table: 'leads',
      },
    ]
    setFilters([...filters, ...selectedFilters])
  }

  return (
    renderSection && (
      <Grid templateColumns={`repeat(auto-fill, minmax(320px, 1fr))`} gap={6}>
        <StatTile height="325px" label="Opt In" alignItems="stretch" Icon={UsersIcon} canCopy>
          <Chart
            {...optIns}
            onSelect={isMobile ? undefined : ({ label }) => handleSelect('optIn', label)}
          />
        </StatTile>

        <StatTile height="325px" label="Follow Ups" alignItems="stretch" Icon={UsersIcon} canCopy>
          <Chart
            {...followUps}
            onSelect={isMobile ? undefined : ({ label }) => handleSelect('followUp', label)}
          />
        </StatTile>
      </Grid>
    )
  )
}
